<section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6">
        <div class="d-flex justify-content-center py-4">
          <a href="index.html" class="logo d-flex align-items-center w-auto">
            <img src="assets/img/logo.png" alt="" />
            <span class="d-none d-lg-block">Patient Tracker</span>
          </a>
        </div>
        <!-- End Logo -->
        <ng-container>
          <div class="card mb-3">
            <div class="card-body">
              <div class="pb-2">
                <h5 class="card-title pb-0 fs-4 mb-2">Reset your password</h5>
                <p class="small">You are Reseting your password for email <b>harsh.rana@mailinator.com</b></p>
              </div>
              <form (ngSubmit)="ChangePassword()" [formGroup]="PasswordForm">
                <div class="form-group mb-3">
                  <label for="newPassword">New Password</label>
                  <div
                    class="input-group"
                    [ngClass]="{
                      'has-invalid': PasswordForm.get('newPassword')?.invalid && PasswordForm.get('newPassword')?.touched
                    }"
                  >
                    <input name="newpassword" type="{{ ShowPasswords ? 'text' : 'password' }}" class="form-control" id="newPassword" formControlName="newPassword" />
                    <ul class="error-message ps-3 mt-1" *ngIf="PasswordForm.get('newPassword')?.invalid && PasswordForm.get('newPassword')?.dirty && PasswordForm.get('newPassword')?.touched">
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['required']">Password is required.</li>
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters long.</li>
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['maxlength']">Password must not exceed 16 characters.</li>
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['uppercase']">Password must contain at least one uppercase letter.</li>
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['lowercase']">Password must contain at least one lowercase letter.</li>
                      <li *ngIf="PasswordForm.get('newPassword')?.errors?.['number']">Password must contain at least one number.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label for="renewPassword">Re-enter New Password</label>
                  <input name="renewpassword" type="{{ ShowPasswords ? 'text' : 'password' }}" class="form-control" id="renewPassword" formControlName="confirmPassword" />
                </div>

                <div class="d-flex justify-content-between">
                  <button class="btn btn-sm btn-link" type="button" tabindex="-1" (click)="ShowPasswords = !ShowPasswords">{{ ShowPasswords ? 'Hide' : 'Show' }} Passwords</button>
                  <button type="submit" [disabled]="PasswordForm.invalid" class="btn btn-primary">Change Password</button>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
